@if (visible()) {
  @switch (variant()) {
    @case ('source') {
      <span class="source">
        <span class="source__label">Fonte:</span>
        <button
          type="button"
          class="source__act"
          [attr.aria-label]="'Ver a fonte: ' + (from()?.actLabel || label())"
          (click)="$event.stopPropagation(); popover.toggle($event)">
          {{ from()?.actLabel || label() }}
        </button>
        @if (from()?.actDate; as date) {
          <span class="source__date">· {{ date | vaultDate }}</span>
        }
        @if (canOpen()) {
          <button type="button" class="source__open" (click)="openSource()">
            · abrir <i class="pi pi-external-link" aria-hidden="true"></i>
          </button>
        }
      </span>
    }
    @case ('icon') {
      @if (changed()) {
        <button
          type="button"
          class="changed"
          [class.changed--user]="isUser()"
          [attr.aria-label]="changedLabel() + ': ver de onde veio'"
          (click)="$event.stopPropagation(); popover.toggle($event)">
          <i class="pi pi-pencil" aria-hidden="true"></i>
          {{ isUser() ? 'corrigido' : changedLabel() }}
        </button>
      } @else {
        <button
          type="button"
          class="icon"
          [class.icon--user]="isUser()"
          [attr.aria-label]="'De onde veio: ' + label()"
          [title]="'De onde veio: ' + label()"
          (click)="$event.stopPropagation(); popover.toggle($event)">
          <i
            class="pi"
            [class.pi-user-edit]="isUser()"
            [class.pi-file]="!isUser()"
            aria-hidden="true"></i>
        </button>
      }
    }
    @default {
      <button
        type="button"
        class="chip"
        [class.chip--user]="isUser()"
        [attr.aria-label]="'De onde veio: ' + label()"
        (click)="$event.stopPropagation(); popover.toggle($event)">
        <i
          class="pi"
          [class.pi-user-edit]="isUser()"
          [class.pi-file]="!isUser()"
          aria-hidden="true"></i>
        {{ label() }}
      </button>
    }
  }

  <p-popover #popover styleClass="charter-provenance-popover" appendTo="body">
    @if (from(); as f) {
      <div class="pop" (click)="$event.stopPropagation()">
        <p class="pop__head">
          @if (current()) {
            <span class="pop__badge">vigente</span>
            <span
              >desde {{ f.actLabel || 'o ato de origem' }}
              @if (f.actDate) {
                ({{ f.actDate | vaultDate }})
              }
            </span>
          } @else {
            <span>
              {{ f.actLabel || 'Ato de origem' }}
              @if (f.actDate) {
                · {{ f.actDate | vaultDate }}
              }
            </span>
          }
        </p>

        <dl class="pop__fields">
          @if (f.documentName) {
            <div>
              <dt>Documento</dt>
              <dd class="pop__doc" [title]="f.documentName">
                <i class="pi pi-file-pdf" aria-hidden="true"></i> {{ f.documentName }}
              </dd>
            </div>
          }
          @if (f.actDate) {
            <div>
              <dt>Data do ato</dt>
              <dd>{{ f.actDate | vaultDate }}</dd>
            </div>
          }
          @if (f.page) {
            <div>
              <dt>Página</dt>
              <dd>{{ f.page }}</dd>
            </div>
          }
        </dl>

        @if (f.quote) {
          <blockquote class="pop__quote">"{{ f.quote }}"</blockquote>
        } @else {
          <p class="pop__muted">O agente não guardou o trecho literal deste valor.</p>
        }

        @if (isUser()) {
          <p class="pop__user">
            <i class="pi pi-user-edit" aria-hidden="true"></i> Valor corrigido por uma pessoa.
          </p>
        }

        @if (canOpen()) {
          <app-button
            [icon]="'pi pi-external-link'"
            [label]="f.page ? 'Abrir documento na página ' + f.page : 'Abrir documento'"
            theme="darkblue"
            [size]="'small'"
            [noMargin]="true"
            (sendButtonClick)="openDocument(popover)" />
        }
      </div>
    }
  </p-popover>
}
